import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import "./FAQs.css";

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`faq-item ${isOpen ? 'active' : ''}`}>
      <button 
        className="faq-question" 
        onClick={toggle}
        aria-expanded={isOpen}
        aria-controls={`faq-answer-${question.replace(/\s+/g, '-').toLowerCase()}`}
      >
        <h3>{question}</h3>
        <span className="toggle-button" aria-hidden="true">
          {isOpen ? <FaMinus /> : <FaPlus />}
        </span>
      </button>
      <div 
        id={`faq-answer-${question.replace(/\s+/g, '-').toLowerCase()}`}
        className={`faq-answer ${isOpen ? 'show' : ''}`}
        role="region"
        aria-hidden={!isOpen}
      >
        {answer}
      </div>
    </div>
  );
};

const FAQContainer = () => {
  const faqs = [
    {
      question: "What are the operating hours?",
      answer: "We are open from 12pm to 10pm, Monday to Friday, and from 11am to 10pm on Saturdays and Sundays."
    },
    {
      question: "Can I bring my own food?",
      answer: "Yes, you can bring your own food to the dog park bar. However, outside drinks are not allowed. We provide water for dogs and humans."
    },
    {
      question: "Are there any breed restrictions?",
      answer: "No, all dog breeds are welcome at the dog park bar. We believe in treating all dogs equally and providing a safe, fun environment for everyone."
    },
    {
      question: "Do I need to make a reservation?",
      answer: "While reservations aren't required, we recommend making one during peak hours (weekends and evenings) to ensure you have a spot. You can make reservations through our website or by calling us directly."
    },
    {
      question: "What are the membership options?",
      answer: "We offer several membership tiers including Day Pass, Monthly, and Annual memberships. Each tier comes with different benefits and access levels. Visit our Membership page for detailed information."
    },
    {
      question: "Are children allowed?",
      answer: "Yes, children are welcome! However, they must be supervised by an adult at all times. We recommend visiting our Rules page to review our family guidelines."
    },
    {
      question: "What amenities do you offer?",
      answer: "We offer a full bar, food service, dog play areas, water stations, shaded seating, and regular events. We also have a retail section with dog supplies and treats."
    }
  ];

  return (
    <div className="faq-container">
      {faqs.map((faq, index) => (
        <FaqItem
          key={index}
          question={faq.question}
          answer={faq.answer}
        />
      ))}
    </div>
  );
};

const FAQs = () => {
  return (
    <div className="faq-wrapper">
      <h1 className="faq-title">Frequently Asked Questions</h1>
      <FAQContainer />
    </div>
  );
};

export default FAQs;
